import React from "react";
import { Card } from "primereact/card";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ProgressSpinner } from "primereact/progressspinner";
import { formatNumber } from "src/utils/helpers";
const DashboardCasesSummaryCard = () => {
  const { t } = useTranslation(["common", "dashboard"]);
  const {
    casesSummary: {
      totalCount,
      inProgress,
      completed,
      pending,
      exceeded,
      onHold,
      withinSLA,
    },
  } = useSelector((state: any) => state.dashboard.dashboardCardsData);

  const isDashboardCardsDataLoaded = useSelector(
    (state: any) => state.dashboard.isDashboardCardsDataLoaded
  );
  return (
    <Card className="card card-1-2">
      <div className="card-content">
        <div className="d-flex gap-2 justify-content-start align-items-center">
          <div className="circle inactive p-4 d-flex justify-content-center align-items-center">
            <SummarizeOutlinedIcon />
          </div>
          <h6 className="card-title">{t("casesSummary")}</h6>
        </div>
        {isDashboardCardsDataLoaded && (
          <div className="card-data d-flex justify-content-between mt-4">
            <div className="d-flex justify-content-between flex-column">
              <div className="d-flex gap-1 mb-2 align-items-center">
                <span className="dot completed"></span>
                <div className="d-flex gap-1 align-items-center case-summary">
                  <span className="font-weight-700" title={completed}>
                    {formatNumber(completed) || 0}
                  </span>
                  <span>{t("completed")}</span>
                </div>
              </div>
              <div className="d-flex gap-1 align-items-center">
                <span className="dot chart-yellow"></span>
                <div className="d-flex gap-1 align-items-center case-summary">
                  <span className="font-weight-700" title={inProgress}>
                    {formatNumber(inProgress) || 0}
                  </span>
                  <span> {t("inProgress")}</span>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between flex-column">
              <div className="d-flex gap-1 mb-2 align-items-center">
                <span className="dot canceled"></span>
                <div className="d-flex gap-1 align-items-center case-summary">
                  <span className="font-weight-700" title={exceeded}>
                    {formatNumber(exceeded) || 0}
                  </span>
                  {t("exceeded")}
                </div>
              </div>
              <div className="d-flex gap-1 align-items-center">
                <span className="dot chart-gray"></span>
                <div className="d-flex gap-1 align-items-center case-summary">
                  <span className="font-weight-700" title={onHold}>
                    {formatNumber(onHold) || 0}
                  </span>
                  <span>{t("onHold")}</span>
                </div>
              </div>
            </div>
          </div>
        )}

        {!isDashboardCardsDataLoaded && <ProgressSpinner />}
      </div>
    </Card>
  );
};

export default DashboardCasesSummaryCard;
